module.exports = __webpack_public_path__ + "img/保护权益@2x.edd6a392.png";